<app-industry-report-details-component></app-industry-report-details-component>

